import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
/*
## Props object for ViewMoreCellMC

text: required
  - String that defines the text to display in the cell.

onClick: optional
  - Function to be called when the button is clicked.

limit: optional
  - Number that defines the character limit to truncate the text.
  - Default value: 100
  - Value: 0 displays the full text and always shows the button.

className: optional
  - String that defines the class name for the text.
*/

const ViewMoreCellMC = ({
  text = '',
  onClick,
  limit,
  className
}) => {
  const maxLimit = limit || 30;
  const { t } = useTranslation();
  const [showFullText, setShowFullText] = useState(false);
  const truncatedText = text?.length > maxLimit ? `${text.substring(0, maxLimit)}...` : text;

  const handleClick = (e) => {
    e.stopPropagation();

    if (onClick) {
      onClick();
    } else if (limit !== 0) {
      setShowFullText(!showFullText);
    }
  };

  return (
    <div className={`tw-wrapper ${className || ''}`}>
      <div className="tw-break-words tw-whitespace-pre-wrap">
        {showFullText ? (
          <span>{text}</span>
        ) : (
          <span>{truncatedText}</span>
        )}
        {(limit === 0 || text?.length > limit) && (
          <button
            type="button"
            className="tw-text-blue-500 tw-ml-1"
            onClick={handleClick}
          >
            {showFullText ? t('table_mc.view_less') : t('table_mc.view_more')}
          </button>
        )}
      </div>
    </div>
  );
};

export default ViewMoreCellMC;
